import { get, del, post } from "@utils/axios";



//custom payitems
export const getAllCustomPayitemsReq = (payload) => {
  return get(`getCustomPayitemsByEmployment?page=${payload.page}&employment_id=${payload.employment_id}&date=${payload.date}&filters=${payload.filters}`)
};

export const getCustomPayitemReq = (payload) => {
  return get(`payitem/${payload.id}/customPayitems?page=${payload.page}&filters=${payload.filters}`)
};

export const getFilterReq = (payload) => {
  return get(`/filters?company_id=1&fields=page=1&filters=supporting_fields_|tax_exempted,employments,currency,payroll,trashed_type,payment_methods;organization_structure_fields_|department;preset_|salary;`)
}
